import Home from './Home'
import Orders from './Orders'
import Execute from './Orders/Execute'
import Profile from './Profile'
import SignUp from './SignUp'
import Account from './Account'
import AccountLaw from './AccountLaw'
import BuyReady from './BuyReady'
import FullPageMenu from './FullPageMenu'
import HeaderTop from './HeaderTop'
import BottomPanel from './BottomPanel'
import Information from './Information'
import SignIn from './SignIn'
import Forgot from './Forgot'
import News from './News'
import AcceptRequest from './AcceptRequest'
import NoMatch from './Commons/NoMatch'

export  {Home, 
        Orders,
        Execute,
        Profile,
        SignUp,
        Account,
        AccountLaw,
        BuyReady,
    	FullPageMenu,
    	HeaderTop,
        BottomPanel,
        Information,
        SignIn,
        Forgot,
        News,
        AcceptRequest,
        NoMatch} 



// WEBPACK FOOTER //
// ./src/components/index.js